module.exports = __webpack_public_path__ + "media/images/v1/banner_long-7e23ea432f518791a47a0a2f400d1dc0.jpg";